<template>
  <div>
    <b-form
      novalidate
      @submit.prevent="submit"
    >
      <validation-observer ref="createBranchRef">
        <b-row>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="Branch Name English"
              rules="required"
            >
              <b-form-group
                label="Branch Name English"
                label-for="branch-name-en"
              >
                <b-form-input
                  id="branch-name-en"
                  v-model="branchData.name.en"
                  placeholder="Branch Name English"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="Branch Name Arabic"
              rules="required"
            >
              <b-form-group
                label="Branch Name Arabic"
                label-for="branch-name-ar"
              >
                <b-form-input
                  id="branch-name-ar"
                  v-model="branchData.name.ar"
                  placeholder="Branch Name Arabic"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col md="12">
            <validation-provider
              #default="{ errors }"
              name="Branch Phone No."
              rules="required"
            >
              <b-form-group
                label="Branch Phone No."
                label-for="branch-phone-no"
              >
                <b-form-input
                  id="branch-phone-no"
                  v-model="branchData.phoneNumber"
                  placeholder="Branch Phone No."
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Place address by"
            >
              <v-select
                v-model="searchType"
                :options="addressSearchOptions"
                :clearable="false"
                :reduce="val => val.value"
                @input="onSearchTypeInput"
              />
            </b-form-group>
          </b-col>

          <b-col
            v-if="searchType == 'PIN_ON_MAP'"
            md="12"
          >
            <validation-provider
              #default="{ errors }"
              name="Branch Address"
              rules="required"
            >
              <b-form-group
                label="Branch Address"
                label-for="branch-address"
              >
                <b-form-input
                  id="branch-address"
                  v-model="address"
                  placeholder="Branch Address"
                />
                <span class="text-danger"> {{ errors[0] }} </span>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col v-else>
            <v-select
              v-model="selectedPlace"
              placeholder="Start typing to search"
              label="description"
              :options="places"
              class="mb-2"
              @search="fetchPlaces"
              @input="onSelectedPlace"
            />
          </b-col>

          <b-col md="12">
            <b-form-group
              label="Branch Location"
            >
              <base-overlay :show="setMarkerLoading">
                <div id="create-branch-map" />
              </base-overlay>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-button
              block
              variant="primary"
              type="submit"
              :disabled="submitting"
            >
              <b-spinner
                v-if="submitting"
                small
              />
              <span v-else>Submit</span>
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-form>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import {
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BRow,
  BCol,
  BSpinner,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// import vSelect from 'vue-select'
import { required } from '@validations'
import { onMounted, ref } from '@vue/composition-api'
import vSelect from 'vue-select'
import { debounce } from 'lodash'
import { errorNotification } from '@/utils/toast-notifications'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'

export default {
  components: {
    vSelect,
    BForm,
    BFormInput,
    BFormGroup,
    BRow,
    BaseOverlay,
    BCol,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    businessId: {
      type: String,
      required: true,
    },
    branch: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const addressSearchOptions = [
      {
        label: 'Search',
        value: 'SEARCH',
      },
      {
        label: 'Pin on map',
        value: 'PIN_ON_MAP',
      },
    ]
    const searchType = ref('PIN_ON_MAP')

    const createBranchRef = ref(null)
    const branchData = ref({
      name: {
        en: '',
        ar: '',
      },
      phoneNumber: null,
    })
    const map = ref(null)
    const marker = ref(null)
    const address = ref('')
    const mapClickListenerPointer = ref(null)
    const registerMapClickListener = () => {
      mapClickListenerPointer.value = map.value.addListener('click', ev => {
        if (marker.value) {
          marker.value.setPosition(ev.latLng)
        } else {
          marker.value = new google.maps.Marker({
            position: ev.latLng,
          })
          marker.value.setMap(map.value)
          marker.value.addListener('click', () => {
            marker.value.setMap(null)
            marker.value = null
          })
        }
      })
    }
    const initMap = () => {
      const center = {
        lat: 31.963158, lng: 35.930359,
      }
      map.value = new google.maps.Map(document.getElementById('create-branch-map'), {
        zoom: 10,
        center,
      })
      if (props.branch) {
        const { lat } = props.branch.location
        const lng = props.branch.location.lon
        marker.value = new google.maps.Marker({
          position: {
            lat,
            lng,
          },
        })
        map.value.setCenter({
          lat,
          lng,
        })
        marker.value.setMap(map.value)
        marker.value.addListener('click', () => {
          marker.value.setMap(null)
          marker.value = null
        })
      }
      registerMapClickListener()
    }
    onMounted(() => {
      initMap()
    })
    const submitting = ref(false)
    const submit = async () => {
      const result = await createBranchRef.value.validate()
      if (!result) return
      if (!marker.value) {
        errorNotification('Provide a branch location')
        return
      }
      submitting.value = true
      try {
        if (props.branch) {
          await ctx.root.$store.dispatch('business/updateBusinessBranch', {
            businessId: props.businessId,
            branchId: props.branch.id,
            data: {
              name: branchData.value.name,
              phoneNumber: branchData.value.phoneNumber,
              address: address.value,
              location: {
                lat: marker.value.position.lat(),
                lon: marker.value.position.lng(),
              },
            },
          })
        } else {
          await ctx.root.$store.dispatch('business/createBusinessBranch', {
            businessId: props.businessId,
            data: {
              name: branchData.value.name,
              phoneNumber: branchData.value.phoneNumber,
              address: address.value,
              location: {
                lat: marker.value.position.lat(),
                lon: marker.value.position.lng(),
              },
            },
          })
        }
        ctx.root.$bvModal.hide('create-branch-modal')
        ctx.emit('refetch')
      } catch (err) {
        const msg = err?.response?.data?.error?.message
        errorNotification(msg)
      } finally {
        submitting.value = false
      }
    }

    const places = ref([])
    const selectedPlace = ref(null)
    const setMarkerLoading = ref(false)
    const fetchPlaces = debounce(async (search, loading) => {
      if (!search) return
      loading(true)
      const res = await axiosIns.get(`/google/search/${search}`)
      places.value = res.data.data.places
      loading(false)
    }, 1000)
    const onSelectedPlace = async () => {
      setMarkerLoading.value = true
      const res = await axiosIns.get(`/google/geocode/${selectedPlace.value.place_id}`)
      const { location } = res.data.data.results.at(0).geometry

      if (marker.value) {
        marker.value.setPosition({
          lat: location.lat,
          lng: location.lng,
        })
        map.value.setCenter({
          lat: location.lat,
          lng: location.lng,
        })
      } else {
        marker.value = new google.maps.Marker({
          position: {
            lat: location.lat,
            lng: location.lng,
          },
        })
      }
      marker.value.setMap(map.value)
      address.value = selectedPlace.value.description
      setMarkerLoading.value = false
    }

    const onSearchTypeInput = evt => {
      if (evt === 'SEARCH') {
        google.maps.event.removeListener(mapClickListenerPointer.value)
      } else {
        registerMapClickListener()
      }
      address.value = ''
      selectedPlace.value = null
      if (marker.value) {
        marker.value.setMap(null)
      }
    }

    if (props.branch) {
      branchData.value.name.en = props.branch.name.en
      branchData.value.name.ar = props.branch.name.ar
      branchData.value.phoneNumber = props.branch.phoneNumber
      address.value = props.branch?.address || ''
    }
    return {
      addressSearchOptions,
      searchType,
      map,
      createBranchRef,
      selectedPlace,
      onSearchTypeInput,
      required,
      places,
      branchData,
      fetchPlaces,
      onSelectedPlace,
      address,
      submitting,
      setMarkerLoading,
      submit,
    }
  },
}
</script>

<style scoped>
#create-branch-map {
    width:100%;
    height: 400px;
}
</style>
